export const API_VERSION = 'v1.0'
const HOST_URL = `ksa.empirecinemas.com`
const LIVEBASEURL = `https://webbrij-api-v1.empirecinemas.com`

let DEVBASEURL = `http://localhost:3800`
let IMG_URL = `https://webbrij-api-v1.empirecinemas.com`

export const ImageS3URL = `https://images.brijimages.com/`
DEVBASEURL = `https://webbrij-api-v1.empirecinemas.com`

export const IMG_BASEURL = IMG_URL

export const BASEURL_BRIJ =
  window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL

export const Empire = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjdlN2IzZWFiLTJlOTEtNDkzOS05ZjBmLTdmMzQyODJmZTZjYSIsImlhdCI6MTY1OTk0MzkxM30.qpq-sdSPtmXu2vHdv4EYembuqM_VaFZdtuCmMI4jhGQ`

export const TOKEN = Empire



// WEBPACK FOOTER //
// ./src/config/index.js